import Viewer from "../../components/Viewer";

const data = {
  title: "5.7. Effectbeoordeling alternatieven",
  content: (
    <>
      <p>
        De alternatieven zijn beoordeeld op dezelfde criteria waarmee in de
        eerste ronde de ruimte binnen de zoekgebieden beoordeeld is. Daarnaast
        is op een rij gezet in hoeverre ze invulling geven aan de doelstellingen
        voor energieproductie. De beoordeling heeft plaatsgevonden in twee
        rondes.
      </p>
      <p>
        In de eerste ronde is alternatief 1 RES 1.0- basis beoordeeld ten
        opzichte van de referentiesituatie (huidige situatie inclusief plannen
        voor wind- en zonne-energie die in ontwikkeling zijn). In de tweede
        ronde is beoordeeld in hoeverre de andere alternatieven beter of minder
        goed beoordeeld worden ten opzichte van alternatief RES 1.0- basis.
      </p>
      <p>
        Door de vergelijking van alternatieven 2, 3 en 4 met alternatief 1 komen
        de onderlinge verschillen scherper in beeld dan wanneer zij alleen met
        de referentiesituatie vergeleken zouden worden. De alternatieven zijn
        immers niet op alle onderdelen fundamenteel verschillend, maar maken
        allemaal gebruik van dezelfde zoekgebieden waarbinnen verschuivingen
        zijn toegepast. Indirect wordt het effect van de alternatieven 2, 3 en 4
        via alternatief 1 wel afgezet tegen de referentiesituatie.
      </p>
      <p>De effecten zijn beoordeeld aan de hand van een 5-puntsschaal:</p>
      <ul>
        <li>Positief effect ++ </li>
        <li>Beperkt positief effect + </li>
        <li>Neutraal effect 0 </li>
        <li>Beperkt negatief effect - </li>
        <li>Negatief effect – </li>
      </ul>

      <h3>
        Beoordeling ronde 1: Alternatief RES 1.0- basis ten opzichte van de
        referentiesituatie
      </h3>

      <table className="w100" id="paragraaf-5-7-1">
        <thead>
          <tr>
            <th>Beoordelingscriterium</th>
            <th>
              Alternatief
              <br />
              RES 1.0- basis
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="kopje ">
            <td colspan="2">Energieproductie</td>
          </tr>
          <tr>
            <td>Opwek wind (TWh/jr)</td>
            <td>0,6</td>
          </tr>
          <tr>
            <td>Aantal windturbines (5,6MW)</td>
            <td>32</td>
          </tr>
          <tr>
            <td>Opwek zon (TWh/jr)</td>
            <td>1,0</td>
          </tr>
          <tr>
            <td>Aantal ha zonnepark</td>
            <td>1460</td>
          </tr>
          <tr>
            <td>Opwek wind + zon (TWh/jr)</td>
            <td>++ (1,6 TWh/jr) </td>
          </tr>
          <tr>
            <td>
              Vermeden CO2-uitstoot op basis te verwachten energieopbrengst in
              TWh
            </td>
            <td>++</td>
          </tr>
          <tr className="kopje wind">
            <td colspan="2">Wind Leefomgeving</td>
          </tr>
          <tr>
            <td>Geluid</td>
            <td>-</td>
          </tr>
          <tr>
            <td>Externe veiligheid</td>
            <td>-</td>
          </tr>
          <tr>
            <td>Woningbouwlocaties</td>
            <td>0</td>
          </tr>
          <tr className="kopje wind">
            <td colspan="2">Wind Natuur</td>
          </tr>
          <tr>
            <td>Natura-2000 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>NNN </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Weidevogelgebieden </td>
            <td>- </td>
          </tr>
          <tr>
            <td>Ganzenrustgebieden </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Stiltegebieden </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Vogels en niet-broedvogels </td>
            <td>-- </td>
          </tr>
          <tr>
            <td>Vogeltrek </td>
            <td>-- </td>
          </tr>
          <tr>
            <td>Vleermuizen </td>
            <td>-- </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="2">Wind Netaansluiting </td>
          </tr>
          <tr>
            <td>Inpassing energie-infrastructuur </td>
            <td>0 </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="2">Wind water </td>
          </tr>
          <tr>
            <td>Drinkwatergebieden </td>
            <td>0 </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="2">Wind Landschap </td>
          </tr>
          <tr>
            <td>Ruimte </td>
            <td>- </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="2">Zon Leefomgeving </td>
          </tr>
          <tr>
            <td>Woningbouwlocaties </td>
            <td>0 </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="2">Zon Natuur </td>
          </tr>
          <tr>
            <td>Natura-2000 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>NNN </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Weidevogelgebieden </td>
            <td>- </td>
          </tr>
          <tr>
            <td>Ganzenrustgebieden </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Stiltegebieden </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Vleermuizen </td>
            <td>- </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="2">Zon Netaansluiting </td>
          </tr>
          <tr>
            <td>Inpassing energie-infrastructuur </td>
            <td>0 </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="2">Zon Water </td>
          </tr>
          <tr>
            <td>Drinkwatergebieden </td>
            <td>0 </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="2">Zon Landschap </td>
          </tr>
          <tr>
            <td>Ruimte </td>
            <td>- </td>
          </tr>
        </tbody>
      </table>
      

      <h4>Toelichting beoordeling ronde 1</h4>
      <p>Wind Leefomgeving</p>
      <ul>
        <li>
          <i>Geluid:</i> Bij het opstellen van de alternatieven zijn
          windturbines buiten de aangehouden afstandsmaten voor geluidbelasting
          geplaatst. Alleen langs de A15 in regio Alblasserwaard bleek dit niet
          mogelijk. Vanwege de toename van de geluidsbelasting ten opzichte van
          de referentiesituatie is een – toegekend (beperkt negatief effect).
        </li>
        <li>
          <i>Externe veiligheid:</i> Bij het opstellen van de alternatieven zijn
          windturbines buiten de aangehouden afstandsmaten voor externe
          veiligheid geplaatst. Omdat ten opzichte van de referentiesituatie een
          beperkte verslechtering plaatsvindt is een – toegekend (beperkt
          negatief effect).
        </li>
        <li>
          <i>Woningbouwlocaties:</i> De zoekgebieden voor windenergie overlappen
          slechts in zeer beperkte mate met beoogde woningbouwlocaties, maar bij
          nadere beschouwing blijkt er voldoende ruimte voor realisatie van
          beide ontwikkelingen: 0 (neutraal).
        </li>
      </ul>

      <p>Wind Natuur</p>
      <ul>
        <li>
          <i>Natura-2000:</i> Er is geen overlap tussen de windturbines in dit
          alternatief en Natura-2000 gebieden: 0 (neutraal).
        </li>
        <li>
          <i>NNN:</i> Er is geen overlap tussen de windturbines in dit
          alternatief en NNN-gebieden: 0 (neutraal).
        </li>
        <li>
          <i>Weidevogelgebieden:</i> De zoekgebieden langs de A4 die in dit
          alternatief worden benut voor windturbines bestaan deels uit
          weidevogelgebied. Het vermijden van deze gebieden bij verder
          uitwerking is lastig: - (beperkt negatief effect).
        </li>
        <li>
          <i>Ganzenrustgebieden:</i> Er <>is </>geen overlap tussen de
          windturbines in dit alternatief en ganzenrustgebieden: 0 (neutraal).
        </li>
        <li>
          <i>Stiltegebieden:</i> Er is geen overlap tussen de windturbines in
          dit alternatief en stiltegebieden: 0 (neutraal).
        </li>
        <li>
          <i>Vogels en niet-broedvogels:</i> Grote delen van de zoekgebieden die
          in dit alternatief worden benut voor de plaatsing van windturbines,
          o.a. langs de A4, bestaan uit gebied waar dit vanuit vogels en
          niet-broedvogels niet kansrijk geacht wordt: -- (negatief effect).
        </li>
        <li>
          <i>Vogeltrek:</i> zoekgebieden die in dit alternatief worden benut
          voor de plaatsing van windturbines, onder andere bij Hoek van Holland
          en in het Rotterdamse Havengebied, bestaan deels uit gebieden waar dit
          vanuit de vogeltrek niet kansrijk geacht wordt: -- (negatief effect).
        </li>
        <li>
          <i>Vleermuizen:</i> zoekgebieden die in dit alternatief worden benut
          voor de plaatsing van windturbines, onder andere rond het Brielse
          Meer, bestaan deels uit gebieden waar dit vanuit vleermuizen niet
          kansrijk geacht wordt: -- (negatief effect).
        </li>
      </ul>

      <p>Wind Netaansluiting </p>
      <ul>
        <li>
          <i>Inpassing energie-infrastructuur:</i> in het algemeen geldt dat het
          Zuid-Hollandse netwerk capaciteit biedt om de RES-opgaven tot 2030 te
          bedienen, of dat dit na aanpassing op korte termijn hiervoor geschikt
          gemaakt kan worden (conclusie Netbeheerders bij beschouwing van de RES
          1.0 uitkomsten). Daarom wordt de score 0 toegekend (neutraal).
        </li>
      </ul>

      <p>Wind Drinkwater </p>
      <ul>
        <li>
          <i>Drinkwatergebieden:</i> Er is geen overlap tussen de windturbines
          in dit alternatief en drinkwatergebieden: 0 (neutraal).
        </li>
      </ul>

      <p>Wind Landschap </p>
      <ul>
        <li>
          <i>Ruimte:</i> Er zijn in dit alternatief geen windturbines geplaatst
          in gebieden die daarvoor vanuit criterium ruimte niet kansrijk geacht
          worden. Het is echter beperkt mogelijk om vast te houden aan het
          regio-overstijgende concept volgens de provinciale plaatsingsvisie,
          met name door de verspreide turbines in regio Holland Rijnland: -
          (beperkt negatief).
        </li>
      </ul>

      <p>Zon Leefomgeving</p>
      <ul>
        <li>
          <i>Woningbouwlocaties:</i> De zoekgebieden voor zonne-energie
          overlappen slechts in zeer beperkte mate met beoogde
          woningbouwlocaties, maar bij nadere beschouwing blijkt er voldoende
          ruimte voor realisatie van beide ontwikkelingen: 0 (neutraal).
        </li>
      </ul>

      <p>Zon Natuur </p>
      <ul>
        <li>
          <i>Natura-2000:</i> Er is geen overlap tussen zonnevelden in dit
          alternatief en Natura-2000 gebieden: 0 (neutraal).
        </li>
        <li>
          <i>NNN:</i> Er is geen overlap tussen de zonnevelden in dit
          alternatief en NNN-gebieden: 0 (neutraal).
        </li>
        <li>
          <i>Weidevogelgebieden:</i> Een deel van de zonnevelden in dit
          alternatief is geprojecteerd in gebieden die van belang zijn voor
          weidevogels, onder andere in de N11 zone, rond de Kagerplassen en ten
          oosten van Alphen. Score – (beperkt negatief).
        </li>
        <li>
          <i>Ganzenrustgebieden:</i> Er is geen overlap tussen de zonnevelden in
          dit alternatief en ganzenrustgebieden: 0 (neutraal).
        </li>
        <li>
          <i>Stiltegebieden:</i> Er is geen overlap tussen de stiltegebieden in
          dit alternatief en stiltegebieden: 0 (neutraal).
        </li>
        <li>
          <i>Vogels en niet-broedvogels:</i> Grote delen van de zoekgebieden die
          in dit alternatief worden benut voor de plaatsing van windturbines,
          onder andere langs de A4, bestaan uit gebied waar dit vanuit vogels en
          niet-broedvogels niet kansrijk geacht wordt: -- (negatief effect).
        </li>
        <li>
          <i>Vogeltrek:</i> zoekgebieden die in dit alternatief worden benut
          voor de plaatsing van windturbines, onder andere bij Hoek van Holland
          en in het Rotterdamse Havengebied, bestaan deels uit gebieden waar dit
          vanuit de vogeltrek niet kansrijk geacht wordt: -- (negatief effect).
        </li>
        <li>
          <i>Vleermuizen:</i> zoekgebieden die in dit alternatief worden benut
          voor de plaatsing van zonnepanelen, onder andere rond het Brielse
          Meer, bestaan deels uit gebieden waar dit vanuit vleermuizen niet
          kansrijk geacht wordt: -- (negatief effect).
        </li>
      </ul>

      <p>Zon Netaansluiting </p>
      <ul>
        <li>
          <i>Inpassing energie-infrastructuur:</i> in het algemeen geldt dat het
          Zuid-Hollandse netwerk capaciteit biedt om de RES-opgaven tot 2030 te
          bedienen, of dat dit na aanpassing op korte termijn hiervoor geschikt
          gemaakt kan worden (conclusie Netbeheerders bij beschouwing van de RES
          1.0 uitkomsten). Daarom, en ook omdat de andere alternatieven met dit
          basisalternatief vergeleken moeten worden, wordt de score 0 toegekend
          (neutraal).
        </li>
      </ul>

      <p>Zon Drinkwater </p>
      <ul>
        <li>
          <i>Drinkwatergebieden:</i> Er is geen overlap tussen de zonnevelden in
          dit alternatief en drinkwatergebieden: 0 (neutraal).
        </li>
      </ul>

      <p>Zon Landschap </p>
      <ul>
        <li>
          <i>Ruimte:</i> Er zijn in dit alternatief zonnevelden geprojecteerd in
          een aantal gebieden die daar vanuit het criterium ruimte niet kansrijk
          geacht worden. Daarom is een score – toegekend (beperkt negatief).
        </li>
      </ul>

      <h4>
        Beoordeling ronde 2: Overige alternatieven ten opzichte van alternatief
        RES 1.0- basis
      </h4>

      <table className="w100" id="paragraaf-5-7-2">
        <thead>
          <tr>
            <th>Beoordelingscriterium </th>
            <th colspan="3" className="alignCenter">Alternatieven</th>
          </tr>
          <tr>
            <th>&nbsp;</th>
            <th>RES 1.0 na besluitvorming </th>
            <th>Landschap </th>
            <th>Haalbaar en betaalbaar (netcapaciteit) </th>
          </tr>
        </thead>
        <tbody>
          <tr className="kopje">
            <td colspan="4">Energieproductie </td>
          </tr>
          <tr>
            <td>Opwek wind (TWh/jr) </td>
            <td>0,6 </td>
            <td>0,6 </td>
            <td>0,8 </td>
          </tr>
          <tr>
            <td>Aantal windturbines (5,6MW) </td>
            <td>32 </td>
            <td>32 </td>
            <td>50 </td>
          </tr>
          <tr>
            <td>Opwek zon (TWh/jr) </td>
            <td>1,0 </td>
            <td>1,0 </td>
            <td>0,8 </td>
          </tr>
          <tr>
            <td>Aantal ha zonnepark </td>
            <td>1500 </td>
            <td>1500 </td>
            <td>1250 </td>
          </tr>
          <tr>
            <td>Opwek wind + zon (TWh/jr) </td>
            <td>0 (1,6 TWh/jr) </td>
            <td>0 (1,6 TWh/jr) </td>
            <td>0 (1,6 TWh/jr) </td>
          </tr>
          <tr>
            <td>
              Vermeden CO2-uitstoot op basis te verwachten energieopbrengst in TWh
            </td>
            <td>0 (neutraal) </td>
            <td>0 (neutraal) </td>
            <td>0 (neutraal) </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="4">Wind Leefomgeving </td>
          </tr>
          <tr>
            <td>Geluid </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Externe veiligheid </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Woningbouwlocaties </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="4">Wind Natuur </td>
          </tr>
          <tr>
            <td>Natura-2000 </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>NNN </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Weidevogelgebieden </td>
            <td>+ </td>
            <td>+ </td>
            <td>-- </td>
          </tr>
          <tr>
            <td>Ganzenrustgebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Stiltegebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Vogels en niet-broedvogels </td>
            <td>0 </td>
            <td>- </td>
            <td>-- </td>
          </tr>
          <tr>
            <td>Vogeltrek </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Vleermuizen </td>
            <td>0 </td>
            <td>0 </td>
            <td>- </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="4">Wind Netaansluiting </td>
          </tr>
          <tr>
            <td>Inpassing energie-infrastructuur </td>
            <td>0 </td>
            <td>- </td>
            <td>+ </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="4">Wind water </td>
          </tr>
          <tr>
            <td>Drinkwatergebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="4">Wind Landschap </td>
          </tr>
          <tr>
            <td>Ruimte </td>
            <td>+ </td>
            <td>++ </td>
            <td>-- </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="4">Zon Leefomgeving </td>
          </tr>
          <tr>
            <td>Woningbouwlocaties </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="4">Zon Natuur </td>
          </tr>
          <tr>
            <td>Natura-2000 </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>NNN </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Weidevogelgebieden </td>
            <td>0 </td>
            <td>+ </td>
            <td>- </td>
          </tr>
          <tr>
            <td>Ganzenrustgebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Stiltegebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Vleermuizen </td>
            <td>0 </td>
            <td>+ </td>
            <td>- </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="4">Zon Netaansluiting </td>
          </tr>
          <tr>
            <td>Inpassing energie-infrastructuur </td>
            <td>0 </td>
            <td>0 </td>
            <td>+ </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="4">Zon Water </td>
          </tr>
          <tr>
            <td>Drinkwatergebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="4">Zon Landschap </td>
          </tr>
          <tr>
            <td>Ruimte </td>
            <td>0 </td>
            <td>++ </td>
            <td>+ </td>
          </tr>
        </tbody>
      </table>

      <h4>Toelichting beoordeling ronde 2</h4>
      <p>De alternatieven 2, 3 en 4 zijn vergeleken met alternatief RES 1.0- basis. Hieronder zijn verschillend in de beoordeling, voor zover daarvan sprake is, toegelicht. </p>

      <strong>Alternatief 2: RES 1.0 na besluitvorming </strong><br />
      <p>Wind Natuur</p>
        <ul><li><i>Weidevogelgebieden:</i> Door het vervallen van de zoekgebieden voor windturbines in het Groene Hart vervalt een aantal locaties waar effect op weidevogels verwacht kan worden. Dit alternatief scoort daarom + (beperkt positief effect ten opzichte van RES 1.0- basis). </li></ul>

        <p>Wind Landschap </p>
        <ul><li><i>Ruimte:</i> Het vervallen van de zoekgebieden voor windturbines in het Groene Hart komt ten goede aan het bovenregionale ruimtelijke concept volgens de provinciale plaatsingsvisie. Dit alternatief scoort daarom + (beperkt positief effect ten opzicht van RES 1.0- basis). </li></ul>

        <strong>Alternatief 3: Landschap </strong><br />

        <p>Wind Natuur </p>
        <ul>
            <li><i>Weidevogelgebieden:</i> In dit alternatief zijn geen windturbines geprojecteerd in de omgeving van de Kagerplassen, rond de A4. Hiermee vervalt een aantal locaties waar effect op weidevogels verwacht kan worden. Dit alternatief scoort daarom + (beperkt positief effect ten opzichte van RES 1.0- basis). </li>
            <li><i>Vogels en niet-broedvogels:</i> In dit alternatief worden meer windturbines geplaatst in gebieden die daarvoor in verband met effect op vogels en niet-broedvogels niet kansrijk voor geacht worden. Score - (beperkt negatief effect ten opzichte van RES 1.0- basis). </li>
        </ul>
 
        <p>Wind Netaansluiting </p>
        <ul><li><i>Inpassing energie-infrastructuur:</i> dit alternatief kent ten opzichte van alternatief RES 1.0- basis meer solitaire windturbines, wat vanuit optiek van de netaansluiting niet efficiënt geacht wordt. Score - (beperkt negatief effect ten opzichte van RES 1.0- basis).</li> </ul>
 
        <p>Wind Landschap </p>
        <ul><li><i>Ruimte:</i> Door het loslaten van de grenzen tussen de energieregio’s voor het realiseren van de opgetelde doelstellingen wordt het mogelijk een sterker boven-regionaal ruimtelijk concept te realiseren voor windenergie. Alternatief landschap is daarom voor dit criterium beoordeeld met ++ (positief effect ten opzicht van RES 1.0- basis).</li> </ul>
        
        <p>Zon Natuur </p>
        <ul>
            <li><i>Weidevogelgebieden</i>: Door de verdeling van zonnevelden in dit alternatief is het mogelijk om ten opzichte van alternatief RES 1.0- basis meer weidevogelgebied te ontzien. Score + (beperkt positief effect ten opzichte van RES 1.0- basis). </li>
            <li><i>Vleermuizen:</i> Door de verdeling van zonnevelden in dit alternatief is het mogelijk om ten opzichte van alternatief RES 1.0- basis meer gebieden die van belang zijn voor vleermuizen te ontzien. Score + (beperkt positief effect ten opzichte van RES 1.0- basis).  </li>
        </ul>

        <p>Zon Landschap </p>
        <ul><li><i>Ruimte:</i> In dit alternatief zijn zonnevelden meer geclusterd, waarmee verrommeling wordt tegengegaan. Bovendien zijn gebieden die vanuit het criterium ruimte niet kansrijk geacht worden (zoals de N11 zone) niet of in mindere mate benut voor zonnevelden. Daarom is een score ++ toegekend (positief effect ten opzichte van alternatief RES 1-basis). </li></ul>

        <strong>Alternatief 4: Haalbaar en betaalbaar (netcapaciteit) </strong><br />




        <p>Wind Natuur</p>
        <ul>
            <li><i>Weidevogelgebieden:</i> In dit alternatief worden ten opzichte van alternatief RES 1.0- basis meer windturbines geplaatst, ook in gebieden die daar vanuit effect op de weidevogels niet kansrijk geacht worden, onder andere ten oosten van Alphen. Dit alternatief scoort daarom <i>-- (negatief</i> effect ten opzichte van RES 1.0- basis). </li>
            <li><i>Vogels en niet-broedvogels:</i> In dit alternatief worden meer windturbines geplaatst in gebieden die daarvoor in verband met effect op vogels en niet-broedvogels niet kansrijk voor geacht worden, onder andere CHECK. Score -- (negatief effect ten opzichte van RES 1.0- basis). </li>
            <li><i>Vleermuizen:</i> In dit alternatief worden meer windturbines geplaatst in gebieden die daarvoor in verband met effect op vleermuizen niet kansrijk voor geacht worden, onder andere rond het Brielse Meer. Score - (beperkt negatief effect ten opzichte van RES 1.0- basis). </li>
        </ul>
 
        <p>Wind Netaansluiting</p>
        <ul><li><i>Inpassing energie-infrastructuur:</i> verwacht wordt dat de in dit alternatief toegepaste principes (meer windturbines ten opzichte van zonnevelden, meer combineren van wind- en zonne-energie, nabijheid van stations met capaciteit) een positief effect heeft op de netaansluiting ten opzichte van alternatief RES 1.0- basis. Score +. </li></ul>
        
        <p>Wind Landschap </p>
        <ul><li><i>Ruimte:</i> Het opvoeren van het aantal windturbines doet afbreuk aan het boven-regionale ruimtelijke concept voor windenergie volgens de provinciale plaatsingsvisie. Alternatief landschap is daarom voor dit criterium beoordeeld met -- (negatief effect ten opzichte van RES 1.0- basis). </li></ul>
        
        <p>Zon Natuur </p>
        <ul>
            <li><i>Weidevogelgebieden:</i> In dit alternatief zijn meer zonnevelden geprojecteerd in gebieden die daar vanuit verwacht effect op weidevogels minder kansrijk voor geacht worden. Daarom scoort dit alternatief – (negatief) ten opzichte van alternatief RES 1.0- basis). </li>
            <li><i>Vleermuizen:</i> In dit alternatief zijn meer zonnevelden geprojecteerd in gebieden die daar vanuit verwacht effect op weidevogels minder kansrijk voor geacht worden, onder andere langs de N11 en ten oosten van Alphen. Daarom scoort dit alternatief – (negatief) ten opzichte van alternatief RES 1.0- basis). </li>
        </ul>

        <p>Wind Netaansluiting </p>
        <ul><li><i>Inpassing energie-infrastructuur:</i> verwacht wordt dat de in dit alternatief toegepaste principes (meer windturbines ten opzichte van zonnevelden, meer combineren van zonne- en windenergie, nabijheid van stations met capaciteit) een positief effect heeft op de netaansluiting ten opzichte van alternatief RES 1.0- basis. Score +. </li></ul>
        
        <p>Zon Landschap </p>
        <ul><li><i>Ruimte:</i> In dit alternatief is minder oppervlak aan zonnevelden nodig en worden deze meer geclusterd, waarmee verrommeling wordt tegengegaan. Hoewel het niet mogelijk is om alle vanuit ruimte kwetsbare gebieden helemaal te ontzien is het effect ten opzichte van alternatief RES 1.0- basis positief: +. </li></ul>

      <Viewer src="https://zuid-holland.maps.arcgis.com/apps/dashboards/cb2d9c9c15a04315919e5b4b83d614ca" />
    </>
  ),
  prev: "/energietransitie-05-05-2022/5/6",
  next: "/energietransitie-05-05-2022/5/8",
};

export default data;
